<template>
  <div class="ruoli-mantra">
    <ruolo-mantra
      v-for="(mantraObj, mantra_id) in Constants.RUOLI_MANTRA"
      :key="mantra_id"
      :mantra-id="mantra_id"
      :outlined="!selectedRuoliMantra.includes(mantra_id)"
      @click="toggleRuoloMantra"
    />
  </div>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import RuoloMantra from "./RuoloMantra";

export default {
  name: "select-ruoli-mantra",
  components: { RuoloMantra },
  mixins: [mixins],
  mounted() {
    console.log("--> SelectRuoliMantra ready.");
  },
  destroyed() {
    console.log("<-- SelectRuoliMantra destroyed.");
  },
  model: {
    prop: "selectedRuoliMantra",
    event: "change",
  },
  props: {
    selectedRuoliMantra: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    toggleRuoloMantra(mantra_id) {
      const selected = this.selectedRuoliMantra.includes(mantra_id)
        ? this.selectedRuoliMantra.filter(id => id !== mantra_id)
        : [...this.selectedRuoliMantra, mantra_id];
      this.$emit("change", selected);
    },
  },
};
</script>

<style lang="scss" scoped>
.ruoli-mantra{
    display: flex;
    gap: 3px;
    flex-wrap: wrap;
}
</style>
